import React from 'react';
import { Box, List, ListItemButton, ListItemText, Paper, Typography } from '@mui/material';

import { SharedComponentSet } from '@paragon/contract-library';

import { useAppSelector } from '../../hooks';

interface Props {
  designUrl: string;
  sampleSharedComponentSets: readonly SharedComponentSet[];
}

/**
 * For use by the `ChooseProjectDialog` only.
 */
export function OpenSamplePanel({ designUrl, sampleSharedComponentSets }: Props) {
  const openContext = useAppSelector((state) => state.application.openContext);

  return (
    <Box sx={{ maxHeight: '400px', width: '100%', overflow: 'auto' }}>
      {sampleSharedComponentSets.length > 0 ? (
        <List>
          {sampleSharedComponentSets.map((sampleSharedComponentSet) => (
            <ListItemButton
              key={sampleSharedComponentSet.lookupCode}
              onClick={() => {
                window.location.href = `${designUrl}${sampleSharedComponentSet.lookupCode}`;
              }}
              selected={
                openContext?.type === 'shared-component-set' &&
                sampleSharedComponentSet.lookupCode === openContext.sharedComponentSetLookupCode
              }
            >
              <ListItemText primary={sampleSharedComponentSet.name} />
            </ListItemButton>
          ))}
        </List>
      ) : (
        <Paper elevation={0} variant="outlined" sx={{ marginTop: 1 }}>
          <Typography variant="body1" color="textSecondary" sx={{ margin: 2 }}>
            No samples available at this time.
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
